// extracted by mini-css-extract-plugin
export default {"title":"title_title__yATgg","title-h1":"title_title-h1__XVDrl","title-h2":"title_title-h2__3vpyH","title-h3":"title_title-h3__ZwzVS","title-h4":"title_title-h4__LbPAq"};